<div class="currency-section">
  <div class="currency-group-label">{{label()}}</div>
  <mat-form-field>
    <input class="pushInput" matInput
           [attr.data-qa]="`${name()}-currency-input`"
           [attr.data-pw]="`${name()}-currency-input`" 
           [disabled]="disabled()"
           [value]="currencyValue()? (currencyValue() | currency) : '$' "  (change)="updateAmount($event)"
           (keypress)="numberOnly($event)">
  </mat-form-field>
</div>